import React from "react";
import "./track.css";

function Track() {
  return <div className="tracking__page">Track</div>;
}

export default Track;
